module.exports = __webpack_public_path__ + "img/icon8.59bfbac5.png";